import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Navbar, BottomNav } from './components/Navigation';
import { Footer } from './components/Footer';
import { HelmetProvider } from './components/SEO';
import { Toaster } from './components/ui/sonner';
import FeedPage from './pages/FeedPage';
import AuthPage from './pages/AuthPage';
import DealSubmitPage from './pages/DealSubmitPage';
import DealDetailPage from './pages/DealDetailPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import LeaderboardPage from './pages/LeaderboardPage';
import ReferralPage from './pages/ReferralPage';
import WachalskiPage from './pages/WachalskiPage';
import BlogListPage from './pages/BlogListPage';
import BlogArticlePage from './pages/BlogArticlePage';
import BlogEditorPage from './pages/BlogEditorPage';
import GroupsPage from './pages/GroupsPage';
import GroupDetailPage from './pages/GroupDetailPage';
import ShopPage from './pages/ShopPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProductSeoEditorPage from './pages/ProductSeoEditorPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { Loader2 } from 'lucide-react';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-primary animate-spin" /></div>;
  return user ? children : <Navigate to="/auth" />;
}

function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-primary animate-spin" /></div>;
  if (!user) return <Navigate to="/auth" />;
  if (!isAdmin) return <Navigate to="/" />;
  return children;
}

function AppContent() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<FeedPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/okazja/:id" element={<DealDetailPage />} />
          <Route path="/deal/:id" element={<DealDetailPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/submit" element={<ProtectedRoute><DealSubmitPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/referral" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />
          <Route path="/wachalski" element={<WachalskiPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/groups/:id" element={<GroupDetailPage />} />
          <Route path="/shop" element={<ProtectedRoute><ShopPage /></ProtectedRoute>} />
          <Route path="/produkty" element={<ProductsPage />} />
          <Route path="/produkt/:id" element={<ProductDetailPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
          <Route path="/admin/blog/new" element={<AdminRoute><BlogEditorPage /></AdminRoute>} />
          <Route path="/admin/blog/edit/:id" element={<AdminRoute><BlogEditorPage /></AdminRoute>} />
          <Route path="/admin/product/:id" element={<AdminRoute><ProductSeoEditorPage /></AdminRoute>} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
          <Route path="/regulamin" element={<TermsPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
      <BottomNav />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
